import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import ArchitectureIcon from '@mui/icons-material/Architecture';
import { IconButton, IconButtonProps, Tooltip } from '@mui/material';

export const ReprocessCriticalGeometryButton = ({
  disabled,
  size = 'small',
  onReprocess,
}: {
  disabled?: boolean;
  size?: IconButtonProps['size'];
  onReprocess?: () => void | Promise<void>;
}) => {
  const { permissions } = useGetCurrentUser();
  const { isCriticalGeometryEnabled, isSupplementalAssetsEnabled } = useFeatureFlags();

  // PUT creates/replaces a supplemental artifact asset → admin-only.
  const canReprocess = permissions.canManageUsers && isCriticalGeometryEnabled && isSupplementalAssetsEnabled;
  if (!canReprocess || !onReprocess) {
    return;
  }

  return (
    <Tooltip title='Update Part Analysis'>
      <span>
        <IconButton
          onClick={() => void onReprocess()}
          size={size}
          disabled={Boolean(disabled)}
          data-testid='reprocess-critical-geometry-button'
        >
          <ArchitectureIcon sx={{ fontSize: '22px' }} />
        </IconButton>
      </span>
    </Tooltip>
  );
};
